import React from "react";
import { Link } from "react-router-dom";

const Header = ({ isAuthenticated, onLogout }) => (
    <header role="navigation" className="App-header bg-transparent">
        <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-md-between">
            <span className="nav-logo" key="home">
                <Link className="" to="/">What We Ate</Link>
            </span>
            <div className="d-flex flex-wrap justify-content-center justify-content-md-between">
            {isAuthenticated ? (
                <>
                <span className="mx-4 my-3 my-md-0">
                    <Link className="btn btn--primary" to="/new">
                        New Post 
                        <span className="ml-2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-plus-circle"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg></span>
                    </Link>
                </span>
                    
                <span className="my-3 my-md-0">
                    <button
                    className="btn btn-link btn--login d-flex"
                    onClick={e => {
                        e.preventDefault();
                        onLogout();
                    }}
                    >
                    Logout
                    <span className="ml-2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-log-out"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg></span>
                    </button>
                </span>
                </>
            ) : (
                <span >
                <Link className="btn btn-link btn--login d-flex" to="/login">
                Login 
                <span className="ml-2"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-log-in"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path><polyline points="10 17 15 12 10 7"></polyline><line x1="15" y1="12" x2="3" y2="12"></line></svg></span>
                </Link>
                </span>
            )}
            </div>
        </div>
    </header>
);

export default Header;